export function setAssetDomain() {
    const assetDomain = (window as any).ASSET_DOMAIN
    if (assetDomain) {
        __webpack_public_path__ = assetDomain
    }
}
